import { EQuizMode, EQuizModeEmojiIcon } from '@constants';
import { Modal } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Wrapper } from './CreateQuizWithNoCourseModal.styles';
import { QuizOptionModal } from './QuizOptionModal';

import FLASHCARDS_IMAGE from '@/assets/flashcards.png';
import { useCreateQuizWithNoCourseModalStore, useGetAvailableQuizModesForStudent } from '@/store';

const IMG_SIZE = 40;

export const CreateQuizWithNoCourseModal = () => {
  const { isOpen, setIsOpen } = useCreateQuizWithNoCourseModalStore();
  const { t } = useTranslation('StudentQuizzesTranslations');
  const { availableQuizModes, isLoading } = useGetAvailableQuizModesForStudent();
  const navigateTo = useNavigate();

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleQuizModeClick = (mode: EQuizMode) => {
    navigateTo(`/tests/configuration?mode=${mode}`);
    handleCancel();
  };

  const handleFlashcardsClick = () => {
    navigateTo('/tests/flashcards');
    handleCancel();
  };

  useEffect(() => {
    return () => {
      handleCancel();
    };
  }, []);

  if (isLoading) return null;

  if (!availableQuizModes) return null;

  return (
    <Modal
      styles={{
        content: {
          overflowY: 'auto',
          width: '600px'
        }
      }}
      centered
      title={t('CREATE_QUIZ_MODAL_TITLE')}
      open={isOpen}
      onCancel={handleCancel}
      footer={null}>
      <Wrapper>
        {Object.keys(availableQuizModes).map(mode => {
          const isAvailable = availableQuizModes[mode as EQuizMode];
          if (!isAvailable) return null;
          return (
            <QuizOptionModal
              key={mode}
              icon={EQuizModeEmojiIcon[mode as EQuizMode]}
              title={t(`${mode as EQuizMode}_MODE_TITLE`)}
              description={t(`${mode as EQuizMode}_MODE_DESCRIPTION`)}
              onClick={() => handleQuizModeClick(mode as EQuizMode)}
            />
          );
        })}
        <QuizOptionModal
          key={'FLASHCARDS'}
          icon={<img src={FLASHCARDS_IMAGE} alt="flashcards" width={IMG_SIZE} height={IMG_SIZE} />}
          title={t(`FLASHCARDS_MODE_TITLE`)}
          description={t(`FLASHCARDS_MODE_DESCRIPTION`)}
          onClick={handleFlashcardsClick}
        />
      </Wrapper>
    </Modal>
  );
};
